import React from 'react'
import { Icon, Typography, Button, Paper } from '@telavita-core/react-design-kit'

import { ReactComponent as NoReservationIcon } from 'static/svg/no-reservation-icon.svg'

import { PortalModal } from 'components/PortalModal/PortalModal'

import * as S from './styles'

interface EmptyReservationProps {
  infoDialog: boolean
  setInfoDialog: (value: boolean) => void
}

interface InfoDialogProps {
  closeDialog: () => void
}

const InfoDialog = ({ closeDialog }: InfoDialogProps) => {
  return (
    <PortalModal
      onClose={closeDialog}
      title='Saiba mais sobre a reserva de horário'
      subtitle=''
    >
      <S.InfoDialogContainer>
        <div className='icon'>
          <Icon name='NoReservation' />
        </div>
        <div className='container'>
          <Typography variant='content1' weight='bold' customClassName='dialogTitle'>
            O que é
          </Typography>

          <Typography variant='content2' customClassName='content'>
            A reserva foi criada para atender quem deseja fazer cada uma de suas consultas <b>num mesmo dia da semana e horário,</b> de forma recorrente.
          </Typography>

          <Typography variant='content1' weight='bold' customClassName='dialogTitle'>
            Como funciona?
          </Typography>
            
          <Typography variant='content2' customClassName='content'>
            Ao obter uma reserva (por exemplo, para quartas-feiras, às 19h00), você continua agendando suas consultas normalmente.
            A grande diferença é que este dia e horário estarão garantidos e aparecerão apenas para você, toda vez que for agendar.
          </Typography>

          <Typography variant='content1' weight='bold' customClassName='dialogTitle'>
            Como consigo uma reserva?
          </Typography>
            
          <Typography variant='content2' customClassName='content'>
            Basta <b>pedir ao seu psicólogo(a) durante uma consulta,</b> no começo ou um pouco antes dela acabar.
          </Typography>

          <Typography variant='content2' customClassName='content'>
            O pedido de reserva está sujeito a indisponibilidade, de acordo com a agenda do profissional. 
            Alguns podem não trabalhar com reserva, também. Pergunte ao seu psicólogo(a).
          </Typography>
            
          <Paper
            variant='warning'
            customClassName='paper'
          >
            <Typography variant='content2'>
              Ao obter uma reserva, é importante se comprometer a <b>agendar no horário reservado,</b> para evitar o cancelamento da mesma.
            </Typography>

          </Paper>

          <Button
            variant='contained'
            color='primary'
            inlineStyles={{ marginBottom: 40, width: '100%' }}
            onClick={closeDialog}
          >
            FECHAR
          </Button>
        </div>
      </S.InfoDialogContainer>
    </PortalModal>
  )
}

export const EmptyReservation = ({
  infoDialog,
  setInfoDialog
}: EmptyReservationProps): JSX.Element => {
  return (
    <>
      <S.EmptyReservationContainer>
        <NoReservationIcon />

        <Typography variant='content2'>
          Nenhuma reserva criada
        </Typography>

        <Typography variant='content3'>
          Garanta consultas num mesmo dia da semana e horário. Peça uma reserva para o seu psicólogo durante a consulta.
        </Typography>

        <Button variant='text' uppercase={false} onClick={() => setInfoDialog(true)}>
          Saiba mais
        </Button>
      </S.EmptyReservationContainer>

      {infoDialog && <InfoDialog closeDialog={() => setInfoDialog(false)} />}
    </>
  )
}
